import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/home/Home'
import Phone from '@/views/phone/Phone'
import Client from '@/views/client/Client'
import Servicing from '@/views/servicing/Servicing'
import Success from '@/views/success/Success'
import FormRegistratorContainer from '@/views/form/FormRegistratorContainer'
import SuccessRegistration from '@/views/success/SuccessRegistration'
import {VIEWS} from '@/views/names'

Vue.use(VueRouter)

const routes = [
    {
        path: '',
        name: VIEWS.preRegistrationFrameProfile.name,
        component: FormRegistratorContainer,
        props: true,
        meta: {
            title: 'init.title'
        }
    },
    {
        path: '/home/',
        name: VIEWS.home.name,
        component: Home,
        props: true,
        meta: {}
    },
    {
        path: '/phone/',
        name: VIEWS.phone.name,
        component: Phone,
        props: true,
        meta: {}
    },
    {
        path: '/client/',
        name: VIEWS.client.name,
        component: Client,
        props: true,
        meta: {}
    },
    {
        path: '/servicing/',
        name: VIEWS.servicing.name,
        component: Servicing,
        props: true,
        meta: {}
    },
    {
        path: '/success/',
        name: VIEWS.success.name,
        component: Success,
        props: true,
        meta: {}
    },
    {
        path: '/success-registration/',
        name: VIEWS.successRegistration.name,
        component: SuccessRegistration,
        props: true,
        meta: {}
    },
    {
        path: '*',
        name: VIEWS.preRegistrationFrameProfile.name,
        component: FormRegistratorContainer,
        props: true,
        meta: {
            title: 'init.title'
        }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: window.frameRegistratorSettings.routerBase,
    routes
})

export default router
